import React from "react";

type EditButtonProps = {
    onClick: () => void;
};

const EditButton: React.FC<EditButtonProps> = ({onClick}) => {
    return (
        <button
            className="flex items-center gap-2 bg-blue-900 text-white px-4 py-2 rounded-lg hover:bg-blue-800 transition"
            onClick={onClick}>
            <svg
                className="w-5 h-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {/* Pencil */}
                <path d="M12 20h9"/>
                <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/>
            </svg>
            <span>Modifica</span>
        </button>
    )
}

export default EditButton;